import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimesheetNumLookupComponent } from './timesheet-num-lookup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: [TimesheetNumLookupComponent],
    exports: [TimesheetNumLookupComponent]
})
export class TimesheetNumLookupModule { }
